module.exports = __webpack_public_path__ + "img/ocean-eye.59e7b3f7.png";